import { beyondSandboxApis } from "./beyond-sandbox";
import { beyondComplianceApis } from "./beyond-compliance";

export const apis = [...beyondSandboxApis, ...beyondComplianceApis,
    {
        type: "file",
        input: "apis/tax-collection-gateway/v1/openapi.yaml",
        path: "/products/tax-collection-gateway/api-reference"
    },
]
